import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'era-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  public ids4ConfigId: string | undefined;
  public azureb2cConfigId: string | undefined;

  constructor() {
    const configs = this.oidcSecurityService.getConfigurations();
    this.ids4ConfigId = configs.find((config) => config?.configId?.startsWith('ids4'))?.configId;
    this.azureb2cConfigId = configs.find((config) => config?.configId?.startsWith('azureb2c'))?.configId;
  }

  login(configId: string) {
    this.oidcSecurityService.authorize(configId);
  }
}
